import { render, staticRenderFns } from "./VaIconVuestic.vue?vue&type=template&id=f3b393c2"
import script from "./VaIconVuestic.vue?vue&type=script&lang=js"
export * from "./VaIconVuestic.vue?vue&type=script&lang=js"
import style0 from "./VaIconVuestic.vue?vue&type=style&index=0&id=f3b393c2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports